module.exports = __webpack_public_path__ + "img/Blurtlogo_v2.4fd70e7f.png";